import React from 'react'
import { FaCircleDot } from 'react-icons/fa6'

const Annual = () => {
  return (
    <div class='annual-div1'>
        <div class='annual-div'>
            {/* <h1 class='service-h'>Annual Maintenance Works</h1> */}
        </div>
        <div class='container'>
            <h1 class='annual-h mt-3'>Reliable maintenance today ensures uninterrupted performance tomorrow.
            Prevent breakdowns before they happen with expert annual maintenance.</h1>
            <div class='row'>
                <div class='col-12 col-sm-12 col-md-6 col-lg-6 mt-4'>
                    <h2 class='annual-h1'>Annual Maintenance Works</h2>
                    <h4 class='annual-h1'>Preventive Maintenance suupport</h4>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>To prepare quarterly and half yearly checklists for all equipments.</span></p>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>To adhere to preventive maintenance plan as per checklists.</span></p>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>To maintain preventive maintenance records.</span></p>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>To comply with all EHS procedures.</span></p>
                </div>
                <div class='col-12 col-sm-12 col-md-6 col-lg-6'>
                    <img src='./Images/img1.jpg' class='home-img mt-5' alt='' />
                </div>
            </div>
            
            <div class='row'>
                <div class='col-12 col-sm-12 col-md-6 col-lg-6'>
                    <img src='./Images/img1.jpg' class='home-img mt-5' alt='' />
                </div>
                <div class='col-12 col-sm-12 col-md-6 col-lg-6 mt-4 mt-5'>
                    <h4 class='annual-h1'>Annual Maintenance support</h4>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>To prepare annual maintenance checklist for each equipment.</span></p>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>To adhere to the annual maintenance schedule and execute annual maintenance as per the checklists.</span></p>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>To upkeep maintenance records.</span></p>
                </div>
                
            </div>
            <div class='row'>
                
                <div class='col-12 col-sm-12 col-md-6 col-lg-6 mt-5'>
                    <h4 class='annual-h1'>Regular Maintenance suupport</h4>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>To prepare and upkeep maintenance checklist for each equipment regularly.</span></p>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>To execute regular maintenance like earth pit resistance check,transformer oil filtration,relaying testing etc.</span></p>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>To adhere strictly to testing requirements regulary.</span></p>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>To coordinate with external vendors/agencies for such testing.</span></p>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>To maintain all test records as per regulatory requirements.</span></p>
                </div>
                <div class='col-12 col-sm-12 col-md-6 col-lg-6'>
                    <img src='./Images/img1.jpg' class='home-img mt-5' alt='' />
                </div>
            </div>
        </div>
        <div class='container'>
            <div class='row'>
                <div class='col-12 col-sm-12 col-md-6 col-lg-4 mt-4'>
                    <h3 class='annual-hh'>🔄Our Maintenance Process</h3>
                    <h4 class='annual-hh1'>1. Inspection & Assessment</h4>
                    <p class='annual-para'>Detailed evaluation of equipment condition</p>
                    <h4 class='annual-hh1'>2. Maintenance Planning</h4>
                    <p class='annual-para'>Customized schedule based on your operational needs</p>
                    <h4 class='annual-hh1'>3. Execution</h4>
                    <p class='annual-para'>Skilled technicians carry out maintenance tasks</p>
                    <h4 class='annual-hh1'>4. Testing & Quality Check</h4>
                    <p class='annual-para'>Ensuring everything runs efficiently and safely</p>
                    <h4 class='annual-hh1'>5. Reporting & Documentation</h4>
                    <p class='annual-para'>Clear reports with recommendations for improvement</p>
                </div>
                <div class='col-12 col-sm-12 col-md-4 col-lg-4 mt-4'>
                    <h3 class='annual-hh'>🏭 Industries We Serve</h3>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>Manufacturing Units</span></p>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>Commercial Buildings</span></p>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>Industrial Plants</span></p>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>Warehouses & Facilities</span></p>
                     <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>Power Plants & Electrical Substations</span></p>
                      <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>Educational Institutions</span></p>
                       <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>Shopping Malls & Retail Outlets</span></p>
                        <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>Hotels & Hospitality Sector</span></p>
                </div>
                <div class='col-12 col-sm-12 col-md-4 col-lg-4 mt-4'>
                    <h3 class='annual-hh'>📊 Benefits of Our AMC</h3>
                    <p><span class='home-para1'>⬇️ Reduced equipment downtime</span></p>
                    <p><span class='home-para1'>💰 Lower maintenance costs</span></p>
                    <p><span class='home-para1'>🔒 Improved safety & compliance</span></p>
                    <p><span class='home-para1'>⚡ Enhanced operational efficiency</span></p>
                    <p><span class='home-para1'>🚀 Priority Service Support</span></p>
                    <p><span class='home-para1'>🛡️ Enhanced Safety Standards</span></p>
                    <p><span class='home-para1'>📅 Planned Maintenance Schedule</span></p>
                    <p><span class='home-para1'>🕒 Reduced Equipment Downtime</span></p>
                </div>
            </div>
        </div>
        <div class='container'>
            <div class='row'>
                <h2 class='annual-hh12 d-flex justify-content-center mt-5'>Why Choose RJ Engineering?</h2>
                <p class='annual-para1 mt-3'>RJ Engineering is committed to delivering reliable, efficient, and cost-effective maintenance solutions tailored to your needs. With a team of skilled professionals and a strong focus on quality, safety, and timely service, we ensure your operations run smoothly with minimal downtime. Our proactive approach, quick response, and customer-centric service make us a trusted partner for all your engineering maintenance requirements.</p>
            </div>
            <div class='row mt-4'>
                <h3 class='annual-hh3'>📞 Get in Touch</h3>
                <h5 class='annual-para12'>Ensure uninterrupted operations with RJ Engineering’s AMC services.</h5>
                <p class='annual-para12'>👉 Contact us today for a customized maintenance plan.</p>
                <button class="button">Get in touch</button>
            </div>
        </div>
    </div>
  )
}

export default Annual